import type { GQL } from "@binale-tech/shared";

export type TTransactionData = Record<string, GQL.IBankingTransaction>;

export type TParseTransaction = Record<keyof GQL.ITransactionCreateInput, string> & {
    myBankAccount?: string;
    myBankIban?: string;
};
